let PAGE_OPTIONS;

export function getPageOptions() {
    return PAGE_OPTIONS;
}

export function setPageOptions(v) {
    PAGE_OPTIONS = v;
}
